import { Tournament } from "@portal-frontend-ssr/blast-api";

export const sortTournamentPrizes = (tournaments: Tournament[]) => {
  return tournaments.toSorted((a, b) => {
    // Extract numeric values from prize pool strings
    const getPrizeValue = (prize: string) => {
      if (!prize) return 0;
      // More efficient regex that directly extracts numbers with decimal points
      const match = prize.match(/[\d,.]+/);
      if (!match) return 0;
      // Remove commas before parsing
      return parseFloat(match[0].replace(/,/g, ""));
    };

    const prizepoolANumber = getPrizeValue(a.prizePool ?? "0");
    const prizepoolBNumber = getPrizeValue(b.prizePool ?? "0");

    // Return the highest prizepool first
    return prizepoolBNumber - prizepoolANumber;
  });
};
